import { baseApi } from '../axios';

export const signUp = async ({ name, email, phoneNumber, domainKey }: any) => {
	const response = await baseApi.post('/auth/signup-send-otp', {
		name,
		email,
		phoneNumber,
		domainKey,
	});

	return response;
};

// verify signup otp
export const verifySignUpOtp = async ({ otp, phoneNumber }: { otp: string; phoneNumber: string }) => {
	const response = await baseApi.post('/auth/signup-verify-otp', {
		otp,
		phoneNumber,
	});
	return response;
};

export const signIn = async ({ name, email, phone, domainKey }: any) => {
	const response = await baseApi.post('/auth/signin-send-otp', {
		name,
		email,
		phone,
		domainKey,
	});

	return response;
};

// verify email send otp
export const verifyEmailSendOtp = async () => {
	const response = await baseApi.post('/auth/otp-email-verification');
	return response;
};

//verify phone send otp
export const verifyPhoneSendOtp = async () => {
	const response = await baseApi.post('/auth/otp-phone-verification');
	return response;
};


// verify signup otp
export const verifySignInOtp = async ({ email, phone, otp }: { email: string; phone: string; otp: string }) => {
	const response = await baseApi.post('/auth/signin-verify-otp', {
		email,
		phone,
		otp,
	});
	return response;
};

export const getUser = async () => {
	const response = await baseApi.get('/auth/me');
	return response;
};

export const getUserProfile = async () => {
	const response = await baseApi.get('/user-profile');
	return response;
};

export const getPresignedUrl = async () => {
	const response = await baseApi.get('/user-profile/s3-presigned-url');
	return response;
};

export const updateUserProfile = async (data: any) => {
	console.log(data);
	const response = await baseApi.patch('/user-profile', data);
	return response;
};

export const updateUser = async (data: any) => {
	const response = await baseApi.patch('/auth/user-update', data);
	return response;
};

// verify email otp
export const verifyEmailOtp = async ({ otp }: { otp: string }) => {
	const response = await baseApi.post('/email-verification/verify-otp', { otp });
	return response;
};

// verify phone otp
export const verifyPhoneOtp = async ({ otp }: { otp: string }) => {
	const response = await baseApi.post('/phone-verification/verify-otp', { otp });
	return response;
};